// extracted by mini-css-extract-plugin
export default {"empty":"Lessons_empty__0JN8o"};